export default class {
  getBiggestRoomOpAmpFromList(vsMinus, vsPlus, opAmpsList, totalGain) {
    //voltage room
    var voltageRoom = this.opAmpVoltageRoom(
      vsMinus,
      vsPlus,
      opAmpsList[0].inHeadroomPlus,
      opAmpsList[0].outHeadroomPlus,
      opAmpsList[0].inHeadroomMinus,
      opAmpsList[0].outHeadroomMinus,
    );
    var biggestRoom = Math.min(voltageRoom.inRoom, voltageRoom.outRoom / totalGain);
    var result = null;
    for (var i = 0; i < opAmpsList.length; i++) {
      var curAmp = opAmpsList[i];
      voltageRoom = this.opAmpVoltageRoom(
        vsMinus,
        vsPlus,
        curAmp.inHeadroomPlus,
        curAmp.outHeadroomPlus,
        curAmp.inHeadroomMinus,
        curAmp.outHeadroomMinus,
      );
      var room = Math.min(voltageRoom.inRoom, voltageRoom.outRoom / totalGain);

      if (room >= biggestRoom) {
        biggestRoom = room;
        result = curAmp;
      }
    }

    return result;
  }
  /**
    @function opampVoltageRoom
    @parameter {int} negVS -Vs
    @parameter {int} posVS +Vs
    @parameter {int} inputHrVPlus opamp.InputHeadroomV+
    @parameter {int} outputHrPlus opamp.OutputHeadroomV+
    @parameter {int} inputHrVMinus opamp.InputHeadroomV-
    @parameter {int} outputHrVMinus opamp.OutputHeadroomV-
    @description calculates inRoom,outRoom,inMax,inMin,outMax,outMin from negVS,posVS,amp vars
    @returns {object} voltageObject contains inRoom,outRoom,inMax,inMin,outMax,outMin
    */
  //inputHrVPlus,outputHrVPlus,inputHrVMinus,outputHrVminus is supposed to come from an opamp object from the DB
  opAmpVoltageRoom(negVSText, posVSText, inputHrVPlusText, outputHrVPlusText, inputHrVMinusText, outputHrVMinusText) {
    var refV, inMax, inMin, outMax, outMin, posInRoom, posOutRoom, negInRoom, negOutRoom, inRoom, outRoom, retObj;
    const negVS = parseFloat(negVSText);
    const posVS = parseFloat(posVSText);
    const inputHrVPlus = parseFloat(inputHrVPlusText);
    const outputHrVPlus = parseFloat(outputHrVPlusText);
    const inputHrVMinus = parseFloat(inputHrVMinusText);
    const outputHrVMinus = parseFloat(outputHrVMinusText);

    if (negVS === 0) {
      refV = posVS / 2;
    } else {
      refV = 0;
    }

    inMax = posVS - inputHrVPlus;
    inMin = negVS + inputHrVMinus;
    outMax = posVS - outputHrVPlus;
    outMin = negVS + outputHrVMinus;

    posInRoom = inMax - refV;
    posOutRoom = outMax - refV;
    negInRoom = refV - inMin;
    negOutRoom = refV - outMin;
    inRoom = Math.min(posInRoom, negInRoom);
    outRoom = Math.min(posOutRoom, negOutRoom);

    retObj = { inRoom: inRoom, outRoom: outRoom, inMax: inMax, inMin: inMin, outMax: outMax, outMin: outMin };

    return retObj;
  }
}
